import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import * as Path from "routes/Path/index";
import { jackpotHistoryDetailsApi } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "react-bootstrap";
import { DATE_FORMAT } from "helpers/common";

const JackpotHistoryView = () => {
  const { id } = useParams();
  const { loading } = useSelector(({ Jackpot }) => Jackpot);
  const [data, setData] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    if (id) {
      dispatch(
        jackpotHistoryDetailsApi({
          data: { _id: id },
          callBack: async (err, response) => {
            const res = response?.data;
            if (res?._id) {
              try {
                setData(res);
              } catch (err) {
                console.error("error inside try useEffetc", err);
              }
            }
          },
        }),
      );
    }
  }, [id]);

  const status = {
    active: "Active",
    completed: "Completed",
  };

  return (
    <>
      <section className="section">
        <div className="section-header">
          <h1>Jackpot Details</h1>

          <div className="section-header-breadcrumb">
            <div className="breadcrumb-item active">
              <Link to={"/admin/" + Path.jackpotHistory}>Jackpot History</Link>
            </div>
            <div className="breadcrumb-item">Jackpot History Detail</div>
          </div>
        </div>
        <div className="section-body">
          <div className="card">
            <Row>
              <Col lg="12" className="my-2 px-4">
                <h4 className="text-primary">Match Details</h4>
                <ul className="list-unstyled ps-0 mb-0 mt-3 row">
                  <li className="col-lg-4 col-sm-6 my-2">
                    <p className=" ">
                      JackpotID :{" "}
                      <span className="font-weight-bold">
                        {data?.jackpotID || "--"}
                      </span>
                    </p>
                  </li>
                  <li className="col-lg-4 col-sm-6 my-2">
                    <p className="">
                      Telegram Username :{" "}
                      <span className="font-weight-bold">
                        {data?.userDetails?.telegram_username || "--"}
                      </span>
                    </p>
                  </li>
                  <li className="col-lg-4 col-sm-6 my-2">
                    <p className="">
                      Email :{" "}
                      <span className="font-weight-bold">
                        {data?.userDetails?.telegramId ||
                          data?.userDetails?.email}
                      </span>
                    </p>
                  </li>
                  <li className="col-lg-4 col-sm-6 my-2">
                    <p className="">
                      Won Energy :{" "}
                      <span className="font-weight-bold">
                        {data?.wonEnergy || 0}
                      </span>
                    </p>
                  </li>
                  <li className="col-lg-4 col-sm-6 my-2">
                    <p className="">
                      Won BTNC :{" "}
                      <span className="font-weight-bold">
                        {data?.wonBtnc || 0}
                      </span>
                    </p>
                  </li>
                  {data?.wonJackpot && (
                    <>
                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className="">
                          Won Amount :{" "}
                          <span className="font-weight-bold">
                            $ {data?.wonAmount || 0}
                          </span>
                        </p>
                      </li>
                      <li className="col-lg-4 col-sm-6 my-2">
                        <p className="">
                          Won Jackpot Type :{" "}
                          <span className="font-weight-bold">
                            {data?.jackpotType || ""}
                          </span>
                        </p>
                      </li>
                    </>
                  )}
                  <li className="col-lg-4 col-sm-6 my-2">
                    <p className="">
                      Status :{" "}
                      <span className="font-weight-bold">
                        {data?.status ? status[data?.status] : "--"}
                      </span>
                    </p>
                  </li>

                  <li className="col-lg-4 col-sm-6 my-2">
                    <p className="">
                      Started At :{" "}
                      <span className="font-weight-bold">
                        {data?.date_created_utc
                          ? DATE_FORMAT(data?.date_created_utc)
                          : "--"}
                      </span>
                    </p>
                  </li>

                  <li className="col-lg-4 col-sm-6 my-2">
                    <p className="">
                      Completed At :{" "}
                      <span className="font-weight-bold">
                        {data?.completedAt
                          ? DATE_FORMAT(data?.completedAt)
                          : "--"}
                      </span>
                    </p>
                  </li>
                </ul>
              </Col>
              <Col lg="12" className="my-2">
                <h4 className="text-primary">Jackpot Details</h4>
                <div className="array-container">
                  {data?.potData?.map((item, index) => (
                    <div key={index} className="array-row">
                      <p className="mt-3 mr-3" style={{ width: 20 }}>
                        {data?.potData?.length - index}
                      </p>
                      {item.row.map((cell, cellIndex) => (
                        <p
                          key={cellIndex}
                          className={`array-cell background-${cell.isOpened} ${cell.type}`}
                        >
                          {cell?.type?.toLowerCase() === "bomb" && (
                            <img
                              className={"leaderboard-icon"}
                              src={cell?.icon}
                            />
                          )}
                          {(cell?.type?.toLowerCase() === "grand" ||
                            cell?.type?.toLowerCase() === "major" ||
                            cell?.type?.toLowerCase() === "minor") && (
                            <>
                              <span className="me-1">
                                {cell.type?.toUpperCase()}
                              </span>
                              <img
                                className={"leaderboard-icon"}
                                style={{ height: 28 }}
                                src={cell?.icon}
                              />
                            </>
                          )}
                          {(cell?.type?.toLowerCase() === "btnc" ||
                            cell?.type?.toLowerCase() === "energy") && (
                            <>
                              <span className="me-1">{cell.value}</span>
                              <img
                                className={"leaderboard-icon"}
                                style={{ height: 28 }}
                                src={cell?.icon}
                              />
                            </>
                          )}
                        </p>
                      ))}
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </section>
    </>
  );
};

export default JackpotHistoryView;
